import getXcsrfToken from './getXcsrfToken';

const getRequestHeaders = () => ({
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-CSRF-TOKEN': getXcsrfToken(),
});

export default getRequestHeaders;



// WEBPACK FOOTER //
// ./utils/getRequestHeaders.js